import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import LoadingButton from './LoadingButton';
import { useTranslation } from 'react-i18next';

// @todo duplicate because other code is not merge https://gitlab.simblesense.io/carbonview/carbonview-frontend/-/merge_requests/696
// @todo merge in feature

function DeleteConfirmDialog(props) {
  const {
    visible,
    isLoading,
    onDiscardHandler,
    onDeleteHandler,
    children,
    headerTitle,
  } = props;
  const { t } = useTranslation();
  return (
    <Modal show={visible} onHide={onDiscardHandler} className="sisde-modal">
      <Modal.Header>
        <Modal.Title>{headerTitle || t('Delete Confirmation')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer>
        <LoadingButton isLoading={isLoading} />
        <Button variant="secondary" onClick={onDiscardHandler}>
          {t('Cancel')}
        </Button>
        <Button variant="danger" onClick={onDeleteHandler} disabled={isLoading}>
          {t('Delete')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DeleteConfirmDialog;
